import { Alert, type AlertColor, AlertTitle, IconButton } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';

import { type CustomAlertProps, type CustomContentProps, useSnackbar } from 'notistack';
import { OpenIcon } from '@/shared/icons/Icons';

type NotificationProps = CustomContentProps & CustomAlertProps;

const NotificationAlert = React.forwardRef<HTMLDivElement, NotificationProps>(
  ({ id, header, variant, message, showOpenIcon, onOpen }, ref) => {
    const severity = (variant === 'default' ? 'info' : variant) as AlertColor;
    const { closeSnackbar } = useSnackbar();
    return (
      <Alert
        ref={ref}
        variant="filled"
        severity={severity}
        action={
          <>
            {showOpenIcon && onOpen && (
              <IconButton
                size="small"
                aria-label="Open"
                title="Open"
                color="inherit"
                onClick={() => onOpen(id)}
              >
                <OpenIcon />
              </IconButton>
            )}
            <IconButton
              size="small"
              aria-label="Close"
              title="Close"
              color="inherit"
              onClick={() => closeSnackbar(id)}
            >
              <FontAwesomeIcon icon={['fad', 'times-circle']} />
            </IconButton>
          </>
        }
      >
        {header && <AlertTitle>{header}</AlertTitle>}
        {message}
      </Alert>
    );
  },
);

export default NotificationAlert;
